import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, withDefaults } from 'vue';
import InputText from '@/modules/shared/components/form/InputText.vue';
import { i18n } from '@/plugins/i18n';

/**
 * Chips input for a list of e-mail addresses (e.g. report recipients).
 * Addresses are trimmed but kept case-sensitive, duplicates are compared exactly.
 */
type Props = {
    value: string[];
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    /** maximum number of addresses, unlimited if not set */
    max?: number;
    /** optional custom validation, replaces the default format/duplicate check */
    validate?: (email: string, existing: string[]) => string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputEmailChips',
  props: {
    value: null,
    label: { default: '' },
    placeholder: { default: '' },
    disabled: { type: Boolean, default: false },
    max: { default: undefined },
    validate: { type: Function, default: undefined }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: string[]): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string[], label: string, placeholder: string, disabled: boolean, max: number, validate: (email: string, existing: string[]) => string[] };





// same rules as the backend: name@domain.tld, no whitespace, ',' or ';', max 255 chars
const EMAIL_PATTERN = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]{2,}$/;

const newEmail = ref<string>('');

const limitReached = computed<boolean>(() => props.max !== undefined && props.value.length >= props.max);

function defaultValidate(email: string, existing: string[]): string[] {
    if (email === '') {
        return [];
    }
    if (email.length > 255 || !EMAIL_PATTERN.test(email)) {
        return [i18n.t('shared.email-chips.invalid').toString()];
    }
    if (existing.includes(email)) {
        return [i18n.t('shared.email-chips.duplicate').toString()];
    }
    return [];
}

const errors = computed<string[]>(() => {
    const email = newEmail.value.trim();
    return props.validate ? props.validate(email, props.value) : defaultValidate(email, props.value);
});

watch(() => props.disabled, (disabled) => {
    if (disabled) {
        newEmail.value = '';
    }
});

function add(): void {
    const email = newEmail.value.trim();
    if (props.disabled || limitReached.value || email === '' || errors.value.length > 0) {
        return;
    }
    emit('input', [...props.value, email]);
    newEmail.value = '';
}

function remove(index: number): void {
    const emails = [...props.value];
    emails.splice(index, 1);
    emit('input', emails);
}

return { __sfc: true,props, emit, EMAIL_PATTERN, newEmail, limitReached, defaultValidate, errors, add, remove, InputText }
}

})